import { MeasuringStrategy, closestCenter, pointerWithin } from '@dnd-kit/core';

/** Measure droppable rects once per drag instead of on every move. */
export const taskTableMeasuring = {
    droppable: {
        strategy: MeasuringStrategy.BeforeDragging,
    },
};

const POINTER_PROXIMITY_PX = 120;
const COLLISION_PRUNE_MIN_DROPPABLES = 32;

const getContainerRect = container => {
    const rect = container.rect;
    if (!rect) return null;
    if (typeof rect === 'object' && 'current' in rect) {
        return rect.current;
    }
    return rect;
};

const pruneDroppablesNearPointer = (droppableContainers, pointerCoordinates) => {
    if (!pointerCoordinates || droppableContainers.length < COLLISION_PRUNE_MIN_DROPPABLES) {
        return droppableContainers;
    }

    const y = pointerCoordinates.y;
    const margin = POINTER_PROXIMITY_PX;
    const pruned = droppableContainers.filter(container => {
        const rect = getContainerRect(container);
        if (!rect) return true;
        return y >= rect.top - margin && y <= rect.bottom + margin;
    });

    return pruned.length > 0 ? pruned : droppableContainers;
};

/**
 * Prefer the row under the pointer; fall back to closest center (same as legacy-only closestCenter in gaps).
 */
export const taskTableCollisionDetection = args => {
    const droppableContainers = pruneDroppablesNearPointer(args.droppableContainers, args.pointerCoordinates);
    const narrowed = { ...args, droppableContainers };

    const pointerHits = pointerWithin(narrowed);
    if (pointerHits.length > 0) {
        return pointerHits;
    }
    return closestCenter(narrowed);
};
